export default '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="m12.1087 10.005 7.8867 7.8866-2.1087 2.1085-7.8866-7.8867-7.89154 7.8916-2.10356422-2.1036 7.89153422-7.8915-7.89653-7.89664 2.1137-2.11326 7.8915 7.90132 7.8864-7.89650372 2.1085 2.10861372z" fill="currentColor"/></svg>';
export const title = "interface-close-small";
export const tags =
  "nordicon interface close remove small cross delete erase symbol";
